import { atom, createStore } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { ExamPostSubjectData } from "../components/examination/type";

export interface ExamSubjectResponse {
  RouteId: number;
  StudentNo: string;
  Amount: number;
  Description: string;
  IsAnnualDue: boolean;
  IsExemptionFee: boolean;
  ExamApplicationId: number;
  Subjects: Subject[];
}

interface Subject {
  Id: number;
  ExamSubjectId: number;
  ExamApplicationId: number;
  AdviceId: number;
  StudentNo: string;
}

interface UserData {
  Token: string;
  MemberId: string;
  Expiration: string;
  AccountType?: any;
  Role: any;
  IsNewApplicant: boolean;
  MembershipTypeId: number;
  Email: null;
  ApplicantId: string;
  ExemptionId: number;
  ExemptionLevelFeeId?: number
  StartDate: string;
  EndDate: null;
  HasPaidExemptionFee: boolean;
  IsOldStudent: boolean;
}

export const myStore = createStore();
export const tokenAtom = atomWithStorage("exam-member-token", "");

const defaultUser = localStorage.getItem("exam-member-user");

export const userAtom = atomWithStorage<UserData>(
  "exam-member-user",
  JSON.parse(defaultUser!) ?? undefined
);

export const profileDetails = atomWithStorage("exam-member-profile-details", {
  FirstName: "",
  MiddleName: "",
  LastName: "",
  MembershipNo: "",
  UploadPictureUrl: "",
  Email: "",
  PhoneNumber: "",
  Gender: "",
});

export const examResponseAtom = atomWithStorage<ExamPostSubjectData>(
  "exam-application-data",
  {
    RouteId: 0,
    StudentNo: "",
    Amount: 0,
    Description: "",
    IsAnnualDue: false,
    IsExemptionFee: false,
    ExamApplicationId: 0,
    Subjects: [],
    ReturnUrl: "",
    ExemptionFee: 0,
    IsLateRegistration: false,
    LateRegistrationFee: 0,
    ExamSubjectsFee: 0,
    ResitFee: 0,
  }
);

export const displayEmailVerifyAtom = atomWithStorage(
  "show-email-verify",
  false
);

export const emailUpdateStatusAtom = atomWithStorage("email-update-status", "");
export const unregisteredExamDataAtom = atomWithStorage(
  "unregistered-exam-length",
  0
);

export const examLocationAtom = atomWithStorage("exam-location", "");
export const examLocationState = atomWithStorage("exam-location-state", "");
export const studyCenterAtom = atomWithStorage("study-center", "");
export const countryIdAtom = atomWithStorage("country-id", "");
export const activeDietAtom = atomWithStorage("active-diet", 0);
export const suspensionAtom = atomWithStorage("suspension-data", {
  isSuspended: false,
  suspensionDuration: "",
});

export const exemptionAtom = atomWithStorage("exemption-data", {
  Id: 0,
  Name: "",
  ExemptionAmount: 0,
  // ExemptionLevelForFeeId: 0,
});
export const inductionStatusAtom = atomWithStorage("induction-status", "");

export const logout = () => {
  localStorage.removeItem("exam-member-token");
  localStorage.removeItem("exam-member-user");
  localStorage.removeItem("exam-member-profile-details");
  localStorage.removeItem("email-update-status");
  window.location.href = "/";
};

export const selectedIndexAtom  = atom<number>(0);